var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignFloor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 220,
    viewBox: "0 0 249 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_23905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.224 208.682H0.760773",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.409 49.9667L149.92 65.5049H107.245L105.876 51.2697C105.59 48.262 107.963 45.6658 110.996 45.6658H142.329C144.859 45.6658 147.006 47.488 147.409 49.9667ZM115.496 63.4965H140.901L139.69 55.9919C139.286 53.5133 137.139 51.691 134.609 51.691H120.026C116.993 51.691 114.62 54.2872 114.905 57.295L115.506 63.4965H115.496Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.356 65.5144H103.68C99.4261 65.5144 95.9896 68.9728 96.0389 73.2052L97.5848 215.508C97.6045 217.487 99.2292 219.084 101.218 219.084H120.094C122.113 219.084 123.748 217.438 123.728 215.43L123.541 198.158C123.511 195.65 125.549 193.602 128.07 193.602H150.767C152.992 193.602 154.893 195.209 155.237 197.403L158.319 216.704C158.595 218.457 160.121 219.75 161.904 219.75H177.776C180.051 219.75 181.774 217.693 181.341 215.459L153.869 71.7062C153.179 68.1204 150.028 65.5242 146.356 65.5242V65.5144Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.834 65.5144H145.509C149.763 65.5144 153.2 68.9728 153.15 73.2052L151.604 215.508C151.585 217.487 149.96 219.084 147.971 219.084H129.095C127.076 219.084 125.442 217.438 125.461 215.43L125.648 198.158C125.678 195.65 123.64 193.602 121.119 193.602H98.4223C96.1969 193.602 94.2965 195.209 93.9519 197.403L90.8698 216.704C90.5941 218.457 89.0679 219.75 87.2856 219.75H71.4127C69.1381 219.75 67.4149 217.693 67.8482 215.459L95.3205 71.7062C96.0098 68.1204 99.1608 65.5242 102.834 65.5242V65.5144Z",
    fill: "#40B0D5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.344 49.9667L102.833 65.5049H145.509L146.878 51.2697C147.163 48.262 144.79 45.6658 141.757 45.6658H110.425C107.895 45.6658 105.748 47.488 105.344 49.9667ZM137.258 63.4965H111.853L113.064 55.9919C113.468 53.5133 115.614 51.691 118.145 51.691H132.728C135.761 51.691 138.144 54.2872 137.848 57.295L137.248 63.4965H137.258Z",
    fill: "#40B0D5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_23905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 220,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignFloor);
export default __webpack_public_path__ + "static/media/sign-floor.a76b9bd0c5e4bd66c5efe6009e1c03cd.svg";
export { ForwardRef as ReactComponent };